import lang from "ac-lang-cn";

lang.init({ zhcn: {
  'UID:P_CORE-YNF-FE_1889CB9A05600006': 'BillNo 为<%=billNo%>的 RootStore 实例已被销毁，内存已回收！',
  'UID:P_CORE-YNF-FE_1895277C05B80007': '批量<%=title%>任务已转入后台执行',
  'UID:P_CORE-YNF-FE_189529FC05B80009': '批量<%=title%>任务执行完毕',
  'UID:P_CORE-YNF-FE_18952C6C05B80007': '草稿【<%=time%>】',
  'UID:P_CORE-YNF-FE_18952DB004500003': '时间【<%=time%>】，当前单据状态，为您保存为草稿',
  'UID:P_CORE-YNF-FE_18952F4804500008': '您于<%=startTime%>发起的【<%=billName%>】导出已经完成，文件名为<%=billName%>,请您参阅查看。',
  'UID:P_CORE-YNF-FE_189530CC05B80003': '【第<%=num%>行】',
  'UID:P_CORE-YNF-FE_1895332E05B80001': '您于<%=time%>发起的导入已经完成。',
  'UID:P_CORE-YNF-FE_189538E404500000': '经初步数据校验，<%=name%>存在<%=count%>处异常，明细如下：',
  'UID:P_CORE-YNF-FE_18953B5805B80006': '【<%=caption%>】是必填条件',
  'UID:P_CORE-YNF-FE_18B4AA0205080005': '共处理<%=totalCount%>条数据，成功<%=successCount%>条数据，失败<%=errorCount%>条数据。请查看错误原因，修改后重新导入。',
  'UID:P_LIB-WEB-YNF-FE_18AC0D4C04380006': '共处理<%=totalCount%>条数据，成功<%=successCount%>条数据，失败<%=errorCount%>条数据。请查看错误原因，修改后重新导入。',
  'UID:P_LIB-WEB-YNF-FE_18AC0E3804480007': '经初步数据校验，<%=filename%>存在<%=errorCount%>处异常，明细如下：',
  'UID:P_LIB-WEB-YNF-FE_18AC0EF404380008': '<%=filename%>无异常数据，可进行导入',
  'UID:P_CORE-YNF-FE_18B26D9605600008': '成功:<%=successCount%>,失败:<%=failCount%>'
}
});
let isShow = false
const loadedGroupCodes = [];

const getMultiLangResource = (args) => {
  return new Promise((resolve, reject) => {
    const context = window.jDiwork?.diworkContext() || {}
    const tenantId = context.tenantid || 0
    const multilingualFlag = context.ext?.multilingualFlag ?? true
    if (isShow) {
      resolve();
      return;
    }
    if (!multilingualFlag && !isShow) {
      isShow = true
      resolve(console.warn('该租户不需要获取多语资源!'))
      return;
    }
    const originUrl = window._YMSHOST_ || '';
    const url = originUrl + '/iuap-apcom-i18n'
    const groupCode = args.langGroupCode
    const libCode = args.providerPackage
    if (!groupCode && libCode) {
      resolve(console.warn('Package:' + libCode + '未注册多语!'))
      return;
    }
    if (loadedGroupCodes.includes(groupCode) || !groupCode) {
      resolve();
      return;
    }
    loadedGroupCodes.push(groupCode)
    lang.jsonpUuid(tenantId, groupCode, url, (data: any) => {
      if (JSON.stringify(data) === '{}') {
        resolve(console.warn('获取到空的多语资源!'))
      } else if (data) {
        resolve(data)
      } else {
        resolve(console.warn('未获取到多语资源!'))
      }
    }, undefined, false)
  })
}

window.load2ndLangResource = getMultiLangResource
